/**
* Web Service handler to retrieve a WSSID from the service to be used in POST requests back to the service
*
* @class WssidWS
*/
function WssidWS ( viewModel ){
	var self = this;

	AbstractWS.apply( this, arguments );

	self.delegate	= null;
	self.name		= 'WssidWS';
	self.wssid		= ko.observable( null );


	/**
	* Defines an error handler for any service requests that fail
	*
	* @method errorHandler
	* @param {JQuery XMLHttpResponse Object} jqXHR
	* @param {String} textStatus
	* @param {Error} errorThrown
	* @return none
	*/
	self.errorHandler = function ( jqXHR, textStatus, errorThrown ) {
		if ( self.delegate == null && self.callback == null ) {
			self.doRequest();
		}
	};


	/**
	* API Endpoint
	*
	* @method
	* @param
	* @return
	*/
	self.serviceURL	= ko.computed( function () {
		return '/qless/api/v1/wssid';
	});


	/**
	* Requests data from the WS. Hands off processing to processData()
	*
	* @method doRequest
	* @param {Object} oDelegate
	* @param {Function} fCallback
	* @return
	*/
	self.doRequest = function ( oDelegate, fCallback ) {
		if ( oDelegate ) {
			self.oDelegate = oDelegate;
		}

		AbstractWS.prototype.doRequest.call( self, fCallback );
	};


	/**
	* Responds to the returned data from the API service call
	*
	* @method processData
	* @param {XMLDocument} xmlData
	* @return none
	*/
	self.processData = function ( xmlData ) {
		self.wssid( $( xmlData ).text() );

		if ( self.delegate ) {
			delegate.doRequest();
			self.delegate = null;
		}
		else if ( self.callback ) {
			self.callback();
			self.callback = null;
		}
	};


		/**
	 * Checks a WS data for an WSSIDException error and then recalls the WSSID
	 * WS, followed by the originating WS
	 *
	 * @method checkResponseForError
	 * @param {Object} WS
	 * @return {Boolean}
	 */
	self.checkResponseForError = function ( WS ) {
		var rootNode = WS.data.firstChild;

		if( rootNode.nodeName === 'error' && $( rootNode ).find('cause').length === 1 ) {
			if( $(rootNode).find('cause')[0].getAttribute('type') === 'WSSIDException' ) {
				console.log('Invalid WSSID.  Refetching and retrying...');
				self.doRequest( WS );
				return true;
			}
		}
		return false;
	};

	return self;
};

WssidWS.prototype = AbstractWS.prototype;
WssidWS.prototype.constructor = WssidWS;
